// JavaScript Document
(function ($) {
  $(function () {
    $(".nav-filter__title").on("click", function () {
      $(this).toggleClass("is-closed");
      $(this).next(".nav-filter__list, .nav-item__priceWrap").slideToggle();
    });
  });

  $(function () {
    // --- 絞り込みパネルを閉じてスクロールロックを解除する共通処理 ---
    function closeFilterModal() {
      $(".modal-filter").removeClass("is-open");
      $(".nav-filterSp__lower").removeClass("is-open"); // 下層パネルもリセット
      $("body").removeClass("is-filter-open");
      window.LafaryScrollLock.unlock();
    }

    $(".btn-filterModal").on("click", function () {
      if ($("body").hasClass("is-filter-open")) return; // 連打で二重にロックしない
      window.LafaryScrollLock.lock();
      $("body").addClass("is-filter-open");
      $(".modal-filter").addClass("is-open");
    });

    $(".nav-filterSp__group-inner").on("click", function () {
      $(this).parent().find(".nav-filterSp__lower").addClass("is-open");
    });

    $(".nav-filterSp__back, .nav-filterSp__back-button").on(
      "click",
      function () {
        console.log("hoge");
        $(".nav-filterSp__lower").removeClass("is-open");
      }
    );

    $(".nav-filterSp__close").on("click", function () {
      // ×はどの階層にいても絞り込みパネル全体を閉じる（1段階だけ戻る「戻る」ボタンとは役割を分ける）
      closeFilterModal();
    });

    // bfcacheからの復元時、ロックが残っていたら解除する
    $(window).on("pageshow", function () {
      if ($("body").hasClass("is-filter-open")) {
        closeFilterModal();
      }
    });

    // 900px以上（.mobileがdisplay:noneになる幅）へ変化したらロックを解除する
    $(window).on("resize", function () {
      if (
        window.matchMedia("(min-width: 900px)").matches &&
        $("body").hasClass("is-filter-open")
      ) {
        closeFilterModal();
      }
    });
  });
})(jQuery);
